import { InvoiceScheme, InvoiceType, PaymentMethodType } from '../Types/invoicesTypes';
import type { CreateInvoiceForm } from '../Types/createInvoiceFormTypes';
import { DEFAULT_INVOICE_TEMPLATE_VARIANT, plusDays, today } from './invoiceHelpers';

// Factory to get a fresh initial state each time (dates computed at call time)
export const createInitialInvoiceForm = (): CreateInvoiceForm => {
  const initialForm: CreateInvoiceForm = {
    reservationId: undefined,
    companyId: undefined, // NEW: Auto-resolved from reservation or manually selected
    useReservationPaymentImport: true,
    type: InvoiceType.Standard,
    currency: 'PLN',

    issueDate: today(),
    saleDate: today(),
    placeOfIssue: 'Kielce',
    paymentMethod: PaymentMethodType.Transfer,
    bankAccount: '',
    paymentDueDate: plusDays(7),

    // Payment fields (for Prepayment invoices)
    status: undefined,
    paidAmount: undefined,
    paidAt: undefined,
    paymentComment: undefined, // Backend: PaymentStatusHelper auto-fills for Cash/Prepayment

    sellerName: '',
    sellerStreetNo: '',
    sellerAddress: '',
    sellerNip: '',

    buyerName: '',
    buyerStreetNo: '',
    buyerAddress: '',
    buyerNip: '',
    buyerCountryIso: 'PL',
    isBuyerVatEu: false,
    buyerIsJst: false,

    useDifferentRecipient: false,
    recipientName: '',
    recipientStreetNo: '',
    recipientAddress: '',
    recipientNip: '',

    comments: '',

    // PDF Template variant (defaults to 'modern')
    templateVariant: DEFAULT_INVOICE_TEMPLATE_VARIANT,

    // PFRON Refund fields
    refundParticipantReferralCost: undefined,
    refundGuardianReferralCost: undefined,
    refundPfronSubsidyParticipant: undefined,
    refundPfronSubsidyGuardian: undefined,
    refundOwnContribution: undefined,

    // Prepayments (Final invoice)
    selectedPrepaymentIds: [],

    items: [],
    scheme: InvoiceScheme.Standard,
  };

  return initialForm;
};
